export function combineUserName(
  user?: {
    firstName: string;
    lastName?: string | null;
  } | null
) {
  const first = user?.firstName ? user.firstName.trim() : 'Unknown';
  const last = user?.firstName ? user.lastName?.trim() || '' : 'User';
  return [first, last].filter((x) => !!x).join(' ');
}
